import { AssetID, DetectionID, ToothDetectionWithMetadata } from '../config';

export const groupToothAndChangesByAsset = (
  dataByAssetIDAndDetection: Map<
    AssetID,
    Map<DetectionID, ToothDetectionWithMetadata>
  >,
) => {
  const result = new Map<AssetID, Map<number, ToothDetectionWithMetadata[]>>();

  dataByAssetIDAndDetection.forEach((detectionMap, assetID) => {
    const isoMap = new Map<number, ToothDetectionWithMetadata[]>();

    detectionMap.forEach((item) => {
      const ISO = item.change?.newNumber || item.tooth.ISO;
      const existingItems = isoMap.get(ISO) || [];
      isoMap.set(ISO, [...existingItems, item]);
    });

    result.set(assetID, isoMap);
  });

  return result;
};
